module.exports = __webpack_public_path__ + "static/media/ktm-06.04e4ca45.jpg";